import React from 'react';

import * as _hm from './_hm';
import * as _ht from './_ht';

export const usePz = ( // page
  itlz?: _ht.dz,
) => {
  const _itlz = {
    bUdt: false, // for udtAll
    page: '', // page name
    role: 'n', // role
    ctt: 'n', // content t: top, c: content, d: detail, l: list
    phs: 'd' as 'c' | 'u' | 'd' | 'h', // phase c: create, u: update, d:, h: history
    idx: -1,
    sort: -1,
    steps: [0, 0, 0],
    tab: '',
    vsn: -1,
    schz: {},
    ... itlz,
  } as _ht.dz;
  const _ls = React.useState(_itlz);
  const _clr = () => _ls[1](_itlz);
  const _set = (pz: _ht.dz) => _ls[1]({ ..._ls[0], ...pz});
  const _rlc = (pz: _ht.dz) => _ls[1](pz);
  const _udtAll = () => _ls[1]({ ..._ls[0], bUdt: !_ls[0].bUdt });
  return {
    crt: _ls[0],
    clr: _clr,
    set: _set,
    rlc: _rlc,
    udtAll: _udtAll,
  }
};

export const useDz = (
  itlz?: _ht.dz,
) => {
  const _ls = React.useState(itlz ?? {});
  return {
    clr: () => _ls[1]({}),
    crt: _ls[0],
    set: (pz: _ht.dz) => _ls[1]({ ..._ls[0], ...pz}),
    rlc: (pz: _ht.dz) => _ls[1](pz),
  }
};

export const useLs = (
  pItls?: _ht.ls,
) => {
  const _ls = React.useState(pItls ?? []);
  return {
    clr: () => _ls[1]([]),
    crt: _ls[0],
    set: (pLs: _ht.ls) => _ls[1](pLs)
  }
};

export const useAny = (
  paItl?: _ht.a,
) => {
  const _ls = React.useState(paItl);
  return {
    clr: () => _ls[1](paItl),
    crt: _ls[0],
    set: (paVle: _ht.a) => _ls[1](paVle)
  }
};

export const udtThis = () => { // 並行実行される場合、複数使用
  const _ls = React.useState(false);
  let _b1 = true;
  return async (_s?: _ht.s) => {
    let _b2 = true;
    while (_b2) {
      if (_b1) {
        _b1 = false;
        await _ls[1](!_ls[0]);
        _b1 = true;
        _b2 = false;
      }
      else {
        await _hm.waitAsync(100);
      }
    }
  }
};
